import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { StripeErrorsMessages } from '../payment-form.interface';

@Component({
  selector: 'cm-payment-form-error',
  templateUrl: 'payment-form-error.component.html',
  styleUrls: ['payment-form-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PaymentFormErrorComponent {
  @Input() errors: StripeErrorsMessages[];
}
